var Common;
(function (Common) {
    var Leaflet;
    (function (Leaflet) {
        var LeafletOptions = (function () {
            function LeafletOptions() {
            }
            return LeafletOptions;
        }());
        var Inset = (function () {
            function Inset(nameProperty, includedFeatures, onPosition, colourIndex, maxRadius, maxPercentage, labelLeft, labelTop, labelHeading) {
                this.nameProperty = nameProperty;
                this.includedFeatures = includedFeatures;
                this.onPosition = onPosition;
                this.colourIndex = colourIndex;
                this.maxRadius = maxRadius;
                this.maxPercentage = maxPercentage;
                this.labelLeft = labelLeft;
                this.labelTop = labelTop;
                this.labelHeading = labelHeading;
            }
            ;
            return Inset;
        }());
        Leaflet.Inset = Inset;
        var ZoomedView = (function () {
            function ZoomedView(map, mapdata, inset, style) {
                var context = this;
                map = map;
                mapdata = mapdata;
                this.nameProperty = inset.nameProperty;
                this.includedFeatures = inset.includedFeatures;
                this.onPosition = inset.onPosition;
                this.style = style;
                this.colourIndex = inset.colourIndex;
                this.maxRadius = inset.maxRadius;
                this.maxPercentage = inset.maxPercentage;
                var latOffset = 0.0;
                var lngOffset = 0.0;
                var center = [0, 0];
                var minLat = 0;
                var maxLat = 0;
                var minLng = 0;
                var maxLng = 0;
                var radius = inset.maxRadius;
                var zoom = map.getZoom();
                var layer;
                var magnifyingGlass;
                function offsetCoordsToLatLng(coords) {
                    return new L.LatLng(coords[1] + latOffset, coords[0] + lngOffset, coords[2]);
                }
                function findBounds() {
                    var names = {};
                    for (var i = 0; i < inset.includedFeatures.length; i++) {
                        names[inset.includedFeatures[i]] = 1;
                    }
                    // Calculate the bounding box for all the points
                    minLat = 90.0;
                    maxLat = -90.0;
                    minLng = 180.0;
                    maxLng = -180.0;
                    window.Leaflet.MapData.features.forEach(function (f) {
                        var name = f.properties[inset.nameProperty];
                        if (name in names) {
                            if (f.geometry.type === "MultiPolygon") {
                                f.geometry.coordinates.forEach(function (c) {
                                    c.forEach(function (p) {
                                        p.forEach(function (q) {
                                            var lat = q[1];
                                            var lng = q[0];
                                            if (lat < minLat)
                                                minLat = lat;
                                            if (lat > maxLat)
                                                maxLat = lat;
                                            if (lng < minLng)
                                                minLng = lng;
                                            if (lng > maxLng)
                                                maxLng = lng;
                                        });
                                    });
                                });
                            }
                            else {
                                f.geometry.coordinates.forEach(function (c) {
                                    c.forEach(function (p) {
                                        var lat = p[1];
                                        var lng = p[0];
                                        if (lat < minLat)
                                            minLat = lat;
                                        if (lat > maxLat)
                                            maxLat = lat;
                                        if (lng < minLng)
                                            minLng = lng;
                                        if (lng > maxLng)
                                            maxLng = lng;
                                    });
                                });
                            }
                        }
                    });
                    var t;
                    if (minLat > maxLat) {
                        t = minLat;
                        minLat = maxLat;
                        maxLat = t;
                    }
                    if (minLng > maxLng) {
                        t = minLng;
                        minLng = maxLng;
                        maxLng = t;
                    }
                    var centerLat = (maxLat - minLat) / 2.0 + minLat;
                    var centerLng = (maxLng - minLng) / 2.0 + minLng;
                    center = [centerLat, centerLng];
                    // Adjust the bounding box to ensure all the points are visible within a constrained circle
                    var testZoom = map.getMaxZoom();
                    var centerProject = map.project(L.latLng(center), testZoom);
                    var bottomProject = map.project(L.latLng(minLat, center[1]), testZoom);
                    var rightProject = map.project(L.latLng(center[0], maxLng), testZoom);
                    var radiusX = rightProject.x - centerProject.x;
                    var radiusY = bottomProject.y - centerProject.y;
                    var initRadius = radiusX;
                    if (radiusX < radiusY)
                        initRadius = radiusY;
                    initRadius = Math.floor(initRadius);
                    var testRadius = initRadius;
                    window.Leaflet.MapData.features.forEach(function (f) {
                        var name = f.properties[inset.nameProperty];
                        if (name in names) {
                            if (f.geometry.type === "MultiPolygon") {
                                f.geometry.coordinates.forEach(function (c) {
                                    c.forEach(function (p) {
                                        p.forEach(function (q) {
                                            var project = map.project(L.latLng(q[1], q[0]), testZoom);
                                            var distX = project.x - centerProject.x;
                                            var distY = project.y - centerProject.y;
                                            var projRadius = Math.sqrt(distX * distX + distY * distY);
                                            if (projRadius > testRadius) {
                                                testRadius = Math.floor(projRadius);
                                            }
                                        });
                                    });
                                });
                            }
                            else {
                                f.geometry.coordinates.forEach(function (c) {
                                    c.forEach(function (p) {
                                        var project = map.project(L.latLng(p[1], p[0]), testZoom);
                                        var distX = project.x - centerProject.x;
                                        var distY = project.y - centerProject.y;
                                        var projRadius = Math.sqrt(distX * distX + distY * distY);
                                        if (projRadius > testRadius) {
                                            testRadius = Math.floor(projRadius);
                                        }
                                    });
                                });
                            }
                        }
                    });
                    if (testRadius > initRadius) {
                        var neLatLng = map.unproject(L.point(centerProject.x + testRadius, centerProject.y - testRadius), testZoom);
                        var swLatLng = map.unproject(L.point(centerProject.x - testRadius, centerProject.y + testRadius), testZoom);
                        minLat = swLatLng.lat;
                        maxLat = neLatLng.lat;
                        minLng = swLatLng.lng;
                        maxLng = neLatLng.lng;
                    }
                }
                function calculateRadiusAndZoom() {
                    var mapSize = map.getSize();
                    var rX = Math.ceil(mapSize.x * inset.maxPercentage);
                    if (rX > inset.maxRadius)
                        rX = inset.maxRadius;
                    var rY = Math.ceil(mapSize.y * inset.maxPercentage);
                    if (rY > inset.maxRadius)
                        rY = inset.maxRadius;
                    if (rX > rY) {
                        radius = rX;
                    }
                    else {
                        radius = rY;
                    }
                    var minZoom = map.getMinZoom();
                    var maxZoom = map.getMaxZoom();
                    var zoomRange = maxZoom - minZoom;
                    var testZoom = minZoom;
                    for (var i = 1; i <= zoomRange; i++) {
                        testZoom = minZoom + i;
                        var centerZoom = map.project(L.latLng(center), testZoom);
                        var bottomZoom = map.project(L.latLng(minLat, center[1]), testZoom);
                        var rightZoom = map.project(L.latLng(center[0], maxLng), testZoom);
                        var radiusX = rightZoom.x - centerZoom.x;
                        var radiusY = bottomZoom.y - centerZoom.y;
                        if (radiusY > rY || radiusX > rX) {
                            testZoom = minZoom + i - 1;
                            break;
                        }
                    }
                    zoom = testZoom;
                }
                function colourise() {
                    var centerZoom = map.project(center, zoom);
                    window.Leaflet.MapData.features.forEach(function (f) {
                        if (f.properties.colourindex !== undefined && f.properties.colourindex >= inset.colourIndex)
                            return;
                        var inShape = false;
                        if (f.geometry.type === "MultiPolygon") {
                            inShape = f.geometry.coordinates.every(function (c) {
                                return c.every(function (p) {
                                    return p.every(function (q) {
                                        var pos = map.project(L.latLng(q[1], q[0]), zoom);
                                        var diffX, diffY;
                                        if (pos.x > centerZoom.x) {
                                            diffX = pos.x - centerZoom.x;
                                        }
                                        else {
                                            diffX = centerZoom.x - pos.x;
                                        }
                                        if (diffX > radius)
                                            return false;
                                        if (pos.y > centerZoom.y) {
                                            diffY = pos.y - centerZoom.y;
                                        }
                                        else {
                                            diffY = centerZoom.y - pos.y;
                                        }
                                        if (diffY > radius)
                                            return false;
                                        var distance = Math.sqrt(diffX * diffX + diffY * diffY);
                                        return distance <= radius;
                                    });
                                });
                            });
                        }
                        else {
                            inShape = f.geometry.coordinates.every(function (c) {
                                return c.every(function (p) {
                                    var pos = map.project(L.latLng(p[1], p[0]), zoom);
                                    var diffX, diffY;
                                    if (pos.x > centerZoom.x) {
                                        diffX = pos.x - centerZoom.x;
                                    }
                                    else {
                                        diffX = centerZoom.x - pos.x;
                                    }
                                    if (diffX > radius)
                                        return false;
                                    if (pos.y > centerZoom.y) {
                                        diffY = pos.y - centerZoom.y;
                                    }
                                    else {
                                        diffY = centerZoom.y - pos.y;
                                    }
                                    if (diffY > radius)
                                        return false;
                                    var distance = Math.sqrt(diffX * diffX + diffY * diffY);
                                    return distance <= radius;
                                });
                            });
                        }
                        if (inShape) {
                            f.properties.colourindex = inset.colourIndex;
                        }
                    });
                }
                function resetHighlight(e) {
                    layer.resetStyle(e.target);
                }
                function onEachFeature(feature, layer) {
                    function navigateToCouncil() {
                        var location = feature.properties[inset.nameProperty]
                            .replace(/\w*(')*\w*/g, function (str) { return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase(); }) // title case
                            .replace(/\s/g, "_"); // replace spaces with underscores
                        window.location.href = "/" + window.StateUrl + "/" + location;
                    }
                    addLabel(feature, layer);
                    layer.on({
                        mouseover: highlightFeature,
                        mouseout: resetHighlight,
                        click: navigateToCouncil
                    });
                }
                function createLayer(offset) {
                    if (offset === undefined) {
                        offset = inset.onPosition(context);
                    }
                    latOffset = offset[0];
                    lngOffset = offset[1];
                    layer = new L.geoJson(window.Leaflet.MapData, {
                        onEachFeature: onEachFeature,
                        style: style,
                        coordsToLatLng: offsetCoordsToLatLng
                    });
                    magnifyingGlass = new L.MagnifyingGlass({
                        fixedZoom: zoom,
                        radius: radius,
                        layers: [layer],
                        fixedPosition: true,
                        latLng: [center[0] + latOffset, center[1] + lngOffset]
                    });
                    $("#leaflet-map").append($("<div/>").attr("style", "left: " + inset.labelLeft + "px; top: " + inset.labelTop + "px;").html(inset.labelHeading).addClass("leaflet-label heading"));
                }
                function addToMap() {
                    if (magnifyingGlass !== undefined) {
                        map.addLayer(magnifyingGlass);
                        map.on("zoom viewreset", handleZoom);
                    }
                }
                function handleZoom() {
                    if (magnifyingGlass !== undefined) {
                        var newOffset = inset.onPosition(context);
                        if (newOffset[0] !== latOffset || newOffset[1] !== lngOffset) {
                            map.removeLayer(magnifyingGlass);
                            createLayer(newOffset);
                            addToMap();
                        }
                    }
                }
                this.getBounds = function () {
                    var allowance = 10;
                    var mapZoom = map.getZoom();
                    if (mapZoom === undefined)
                        mapZoom = map.getMinZoom();
                    var centerPoint = map.project(L.latLng(center[0] + latOffset, center[1] + lngOffset), mapZoom);
                    var north = centerPoint.y - radius - allowance;
                    var south = centerPoint.y + radius + allowance;
                    var east = centerPoint.x + radius + allowance;
                    var west = centerPoint.x - radius - allowance;
                    var southWest = map.unproject(L.point(west, south), mapZoom);
                    var northEast = map.unproject(L.point(east, north), mapZoom);
                    return L.latLngBounds(southWest, northEast);
                };
                this.positionRelativeTo = function (anchor, relative, adjX, adjY) {
                    var mapZoom = map.getZoom();
                    if (mapZoom === undefined)
                        mapZoom = map.getMinZoom();
                    var centerPoint = map.project(L.latLng(center[0], center[1]), mapZoom);
                    var locusPoint, factorX = 1.0, factorY = 1.0;
                    if (relative === "right") {
                        locusPoint = L.point(centerPoint.x + radius, centerPoint.y);
                        factorX = -1.0;
                    }
                    else if (relative === "top") {
                        locusPoint = L.point(centerPoint.x, centerPoint.y + radius);
                        factorY = -1.0;
                        factorX = -1.0;
                    }
                    else if (relative === "bottom") {
                        locusPoint = L.point(centerPoint.x, centerPoint.y - radius);
                        factorX = -1.0;
                    }
                    else {
                        locusPoint = L.point(centerPoint.x - radius, centerPoint.y);
                    }
                    var locus = map.unproject(L.point(locusPoint.x + adjX, locusPoint.y + adjY), mapZoom);
                    return [(locus.lat - anchor.lat) * factorY, (locus.lng - anchor.lng) * factorX];
                };
                this.addToMap = addToMap;
                findBounds();
                calculateRadiusAndZoom();
                colourise();
                createLayer(undefined);
            }
            return ZoomedView;
        }());
        var codesArray;
        function loadLeafletMap(stateCode, assemblyVersion, codes, customZoom) {
            if (customZoom === void 0) { customZoom = 5; }
            var zoom = customZoom;
            codesArray = codes;
            window.Leaflet = new LeafletOptions();
            window.Leaflet.CodesArray = codes;
            var processing = $("<div>").attr("style", "margin: auto; text-align: center;").append($("<img>").attr("src", "/_static/images/processing.gif"));
            $("#leaflet-map").html(processing.html());
            var configUrl = "/_static/data/config_" + stateCode + ".js?v=" + assemblyVersion;
            var dataUrl = "/_static/data/data_" + stateCode + ".js?v=" + assemblyVersion;
            // Asynchronously load map data before attempting to construct it
            $.ajax({
                url: configUrl,
                method: "GET",
                dataType: "script",
                cache: true
            })
                .done(function () {
                    $.ajax({
                        url: dataUrl,
                        method: "GET",
                        dataType: "script",
                        cache: true
                    })
                        .done(function () {
                            // Check for custom zoom set in config
                            if (window.Leaflet.MapZoomLevel) {
                                zoom = window.Leaflet.MapZoomLevel;
                            }
                            var mapZoom = zoom;
                            var map = L.map("leaflet-map", {
                                measureControl: false,
                                attributionControl: false,
                                zoomControl: false,
                                maxZoom: 14,
                                minZoom: mapZoom,
                                zoom: mapZoom,
                                trackResize: true
                            });
                            // disable any zooming or scrolling control over the map
                            map.dragging.disable();
                            map.touchZoom.disable();
                            map.doubleClickZoom.disable();
                            map.scrollWheelZoom.disable();
                            map.boxZoom.disable();
                            map.keyboard.disable();
                            if (typeof window.Leaflet.Inset1Data !== "undefined") {
                                window.Leaflet.Inset1 = new ZoomedView(map, window.Leaflet.MapData, window.Leaflet.Inset1Data, styleFeature);
                            }
                            if (typeof window.Leaflet.Inset2Data !== "undefined") {
                                window.Leaflet.Inset2 = new ZoomedView(map, window.Leaflet.MapData, window.Leaflet.Inset2Data, styleFeature);
                            }
                            var lga;
                            function resetHighlight(e) {
                                lga.resetStyle(e.target);
                            }
                            function onEachFeature(feature, layer) {
                                function navigateToCouncil() {
                                    var location = feature.properties[window.Leaflet.NameProperty]
                                        .replace(/\w*(')*\w*/g, function (str) { return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase(); }) // title case
                                        .replace(/\s/g, "_"); // replace spaces with underscores
                                    // StateUrl property is set in data_ACT.js to use correct state
                                    var state = feature.properties['StateUrl'];
                                    if (!state)
                                        state = window.StateUrl;
                                    window.location.href = "/" + (typeof state === "undefined" ? location : state + "/" + location);
                                }
                                addLabel(feature, layer);
                                layer.on({
                                    mouseover: highlightFeature,
                                    mouseout: resetHighlight,
                                    click: navigateToCouncil
                                });
                            }
                            lga = new L.geoJson(window.Leaflet.MapData, {
                                onEachFeature: onEachFeature,
                                style: styleFeature
                            });
                            var mainBounds = lga.getBounds();
                            var south = mainBounds.getSouth();
                            var west = mainBounds.getWest();
                            var north = mainBounds.getNorth();
                            var east = mainBounds.getEast();
                            if (typeof window.Leaflet.Inset1 !== "undefined") {
                                var inset1Bounds = window.Leaflet.Inset1.getBounds();
                                if (inset1Bounds.getSouth() < south)
                                    south = inset1Bounds.getSouth();
                                if (inset1Bounds.getWest() < west)
                                    west = inset1Bounds.getWest();
                                if (inset1Bounds.getNorth() > north)
                                    north = inset1Bounds.getNorth();
                                if (inset1Bounds.getEast() > east)
                                    east = inset1Bounds.getEast();
                            }
                            if (typeof window.Leaflet.Inset2 !== "undefined") {
                                var inset2Bounds = window.Leaflet.Inset2.getBounds();
                                if (inset2Bounds.getSouth() < south)
                                    south = inset2Bounds.getSouth();
                                if (inset2Bounds.getWest() < west)
                                    west = inset2Bounds.getWest();
                                if (inset2Bounds.getNorth() > north)
                                    north = inset2Bounds.getNorth();
                                if (inset2Bounds.getEast() > east)
                                    east = inset2Bounds.getEast();
                            }
                            map.fitBounds([
                                [south, west],
                                [north, east]
                            ]);
                            map.addLayer(lga);
                            if (typeof window.Leaflet.Inset1 !== "undefined") {
                                window.Leaflet.Inset1.addToMap();
                            }
                            if (typeof window.Leaflet.Inset2 !== "undefined") {
                                window.Leaflet.Inset2.addToMap();
                            }
                        })
                        .always(function () {
                            if ($("#leaflet-map img").length > 0) {
                                $("#leaflet-map img")[0].remove();
                            }
                        });
                })
                .fail(function (e) {
                    $("#mapSelector").hide();
                    $("#mapUnavailable").show();
                })
                .always(function () {
                    if ($("#leaflet-map img").length > 0) {
                        $("#leaflet-map img")[0].remove();
                    }
                });
        }
        var colours = [
            [
                "#61a8ff",
                "#61d0ff",
                "#61c2ff",
                "#61b5ff",
                "#619bff",
                "#618eff",
                "#6181ff"
            ],
            [
                "#ff6961",
                "#ff6181",
                "#ff6173",
                "#ff6166",
                "#ff7661",
                "#ff8361",
                "#ff9161"
            ],
            [
                "#61ff69",
                "#81ff61",
                "#73ff61",
                "#66ff61",
                "#61ff76",
                "#61ff83",
                "#61ff91"
            ]
        ];
        var c = 0;
        var colourLength = colours[0].length;
        function highlightFeature(e) {
            var layer = e.target;
            layer.setStyle({
                weight: 3,
                color: "#666",
                dashArray: "",
                fillOpacity: 0.7
            });
            if (!L.Browser.ie && !L.Browser.opera) {
                layer.bringToFront();
            }
        }
        function styleFeature(feature) {
            var fillColour;
            if (typeof codesArray === "undefined" && typeof window.Leaflet.ColourOverrides === "undefined") {
                if (feature.properties.colour === undefined) {
                    c++;
                    if (c >= colourLength)
                        c = 0;
                    feature.properties.colour = c;
                }
                if (feature.properties.colourindex === undefined) {
                    feature.properties.colourindex = 0;
                }
                var colourIndex = feature.properties.colourindex;
                if (typeof window.Leaflet.ApplyColourIndexTo !== "undefined" && typeof window.Leaflet.ColourIndexOverride !== "undefined" && window.Leaflet.ApplyColourIndexTo.indexOf(feature.properties[window.Leaflet.NameProperty]) >= 0) {
                    colourIndex = window.Leaflet.ColourIndexOverride;
                }
                fillColour = colours[colourIndex][feature.properties.colour];
            }
            else {
                var lookup = feature.properties["Key"];
                var result = $.grep(codesArray, function (e) { return e.key === lookup; });
                if (result.length === 1) {
                    var colourResult = $.grep(window.Leaflet.ColourOverrides, function (e) { return e.code === result[0].code; });
                    if (colourResult.length === 1) {
                        fillColour = colourResult[0].colour;
                    }
                }
                if (fillColour === undefined) {
                    fillColour = colours[0][0];
                }
            }
            return {
                weight: 1.0,
                colour: "black",
                fillColor: fillColour,
                dashArray: "",
                opacity: 1.0,
                fillOpacity: 0.5
            };
        }
        function addLabel(feature, layer) {
            layer.bindLabel(feature.properties[window.Leaflet.NameProperty].replace(/\w*(')*\w*/g, function (str) { return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase(); }), { direction: 'auto' });
        }
        function Init(state, assemblyVersion, statesArray, customZoom) {
            if (customZoom === void 0) { customZoom = 3.8; }
            if (state) {
                $(window).on("resize", function () {
                    if ($("#leaflet-map:visible").length && !$("#leaflet-map.leaflet-container").length) {
                        loadLeafletMap(state, assemblyVersion, statesArray, customZoom);
                    }
                });
                if (!$("#leaflet-map:visible").length) {
                    return;
                }
                loadLeafletMap(state, assemblyVersion, statesArray, customZoom);
            }
        }
        Leaflet.Init = Init;
    })(Leaflet = Common.Leaflet || (Common.Leaflet = {}));
})(Common || (Common = {}));
